<div class="wrap">
    <div class="header">
        <h1> Camera management</h1>

    </div>

    <div class="container">

        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'"> Name </th>
                <td mat-cell *matCellDef="let element" [style.text-align]="'center'"> {{element?.name}} </td>
            </ng-container>

            <ng-container matColumnDef="battery">
                <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'">
                    Battery </th>
                <td mat-cell *matCellDef="let element" [style.text-align]="'center'"> {{element.battery}}% </td>
            </ng-container>


            <ng-container matColumnDef="lastLogon">
              <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'"> Last logon </th>
              <td mat-cell *matCellDef="let element" [style.text-align]="'center'"> {{element?.lastLogon | date : 'short'}} </td>
          </ng-container>

          <ng-container matColumnDef="externalId">
            <th mat-header-cell *matHeaderCellDef [style.text-align]="'center'"> Id </th>
            <td mat-cell *matCellDef="let element" [style.text-align]="'center'"> {{element?.externalId}} </td>
        </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        </table>
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
            aria-label="Select page">
        </mat-paginator>

        <!-- <mat-accordion>
            <mat-expansion-panel *ngFor="let c of clients">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{c?.name}}

                    </mat-panel-title>

                </mat-expansion-panel-header>

                <mat-accordion>

                    <app-application-camera-table [cameras]="c?.camera">

                    </app-application-camera-table>

                </mat-accordion>
            </mat-expansion-panel>
        </mat-accordion> -->


    </div>

</div>
